import React from "react"
import Materials from "@/components/Materials"

export default function MaterialsView() {
  return <Materials />
}
